import React, {useEffect, useState} from 'react';
import { cpfCnpjMask, phoneMask } from '../Utils/Mask';
import Background from '../assets/portal.png';
import BackgroundMobile from '../assets/portal_mobile.png';
import { useHistory } from 'react-router-dom';
import {Button, Spinner, Container, Alert, Col, Nav, Form} from 'react-bootstrap';
import * as FaIcons from 'react-icons/fa';
import { CardInfo } from '../components/CardInfo/CardInfo';
import { CardBody } from '../components/CardBody/CardBody';
import { CardHeader } from '../components/CardHeader/CardHeader';
import { useAuth, isChallenge, ChallengeProps, Canal } from '../contexts/AuthenticationContext';
import { Input } from '../components/Input/Input';
import Navbar from "react-bootstrap/Navbar";
import logoImg from "../assets/netcomet2.png";
import appleImg from "../assets/apple.png";
import androidImg from "../assets/android.png";

export function Login() {
	const history = useHistory();
	const { session, signIn, verifyCode } = useAuth();

	const InstagramIcon = FaIcons.FaInstagram as React.FC<{ size?: number; color?: string }>;
	const FaceboookIcon = FaIcons.FaFacebook as React.FC<{ size?: number; color?: string }>;
	const SmsIcon = FaIcons.FaSms as React.FC<{ className?: string }>;
	const WhatsappIcon = FaIcons.FaWhatsapp as React.FC<{ className?: string }>;
	const EnvelopeIcon = FaIcons.FaEnvelope as React.FC<{ className?: string }>;
	const RedoIcon = FaIcons.FaRedo as React.FC<{ className?: string }>;
	const ExchangeIcon = FaIcons.FaExchangeAlt as React.FC<{ className?: string }>;
	const ArrowLeftIcon = FaIcons.FaArrowLeft as React.FC<{ className?: string }>;

	const urlParams = new URLSearchParams(window.location.search);
	const documentParam = urlParams.get('d');
	const phoneParam = urlParams.get('t');
	const localParam = urlParams.get('local');

	const [message, setMessage] = useState<string>('');
	const [messageType, setMessageType] = useState<string>('');
	const [loading, setLoading] = useState(false);
	const [document, setDocument] = useState('');
	const [phone, setPhone] = useState('');

	//segundo fator: desafio devolvido pelo /login, codigo digitado e "lembrar este navegador"
	const [desafio, setDesafio] = useState<ChallengeProps | null>(null);
	const [codigo, setCodigo] = useState('');
	const [lembrar, setLembrar] = useState(true);
	//canal escolhido para receber o codigo (sms | whatsapp | email); o reenvio usa o mesmo
	const [canal, setCanal] = useState<Canal>('sms');

	const NOME_CANAL: Record<Canal, string> = { sms: 'SMS', whatsapp: 'WhatsApp', email: 'e-mail' };

	const isMobile = window.innerWidth <= 768;
	const backgroundImage = isMobile ? BackgroundMobile : Background;

	const limparDocumento = (valor: string) => valor.replace(/\.|-|\//g, '').trim();
	const limparTelefone = (valor: string) => valor.replace(/\(|\)|-|\s/g, '').trim();

	useEffect(() => {
		if (documentParam && phoneParam) {
			setDocument(cpfCnpjMask(documentParam));
			setPhone(phoneMask(phoneParam));
			signIn(limparDocumento(documentParam), limparTelefone(phoneParam), 'login')
				.then((resultado) => {
					if (isChallenge(resultado)) {
						setDesafio(resultado);
						setCodigo('');
						setLoading(false);
						return;
					}
					history.push('menu');
				})
				.catch(() => {
					history.push('login');
				});
		}
	},[documentParam, phoneParam, signIn, history]);

	useEffect(() => {
		if (session) {
			if (localParam) {
				history.push('menu?local='+localParam);
			} else {
				history.push('menu');
			}
		}
	},[history, session, localParam]);

	/**
	 * Sem "enviar": a API confere CPF + telefone e, se o navegador nao for lembrado, devolve so o aviso com os
	 * canais disponiveis e os destinos mascarados (tela de escolha). Com enviar = true, envia o codigo pelo canal.
	 */
	function handleLogin(enviar = false, canalEscolhido?: Canal){
		if(!document){
			setMessage('Você precisa informar um documento');
			setMessageType('warning');
			return false;
		}

		if(!phone){
			setMessage('Você precisa informar um telefone');
			setMessageType('warning');
			return false;
		}

		setLoading(true);

		const reenvio = enviar && desafio !== null && desafio.desafio !== null;
		const canalEnvio: Canal = canalEscolhido || canal;

		signIn(limparDocumento(document), limparTelefone(phone), 'login', enviar, canalEnvio)
			.then((resultado) => {
				if (isChallenge(resultado)) {
					if (enviar) setCanal(resultado.canal || canalEnvio);
					setDesafio(resultado);
					setCodigo('');
					setMessage(resultado.desafio ? (reenvio ? 'Código reenviado' : 'Código enviado') : '');
					setMessageType('info');
					setLoading(false);
					return;
				}
				history.push('menu');
			}).catch((error) => {
				setMessage(error);
				setMessageType('danger');
				setLoading(false);
			});
	}

	function handleVerify(){
		if (!desafio || !desafio.desafio) {
			return;
		}
		if (codigo.length !== 6) {
			setMessage('Digite o código de 6 dígitos');
			setMessageType('warning');
			return;
		}

		setLoading(true);

		verifyCode(desafio.desafio, codigo, lembrar, 'login')
			.then(() => {
				history.push('menu');
			}).catch((error) => {
				setMessage(error);
				setMessageType('danger');
				setLoading(false);
			});
	}

	function handleVoltar(){
		setDesafio(null);
		setCodigo('');
		setMessage('');
	}

	return(
		<>
			{loading && <div className="vh-100 justify-content-center align-items-center d-flex">
				<Spinner animation="border" role="status"/>
			</div>
			}
			{!loading && <>
				<Navbar collapseOnSelect style={{height: 80, background: "#006996"}} className="header p1 align-content-center" expand="lg">
					<Container>
						<Navbar.Brand className="ms-2 ">
							<img src={logoImg} alt="Logo Netcomet" width={isMobile ? 130 : 160} style={{cursor: 'pointer'}} onClick={() => window.open('https://www.netcomet.com.br', '_blank')}/>
						</Navbar.Brand>
						<Navbar.Brand id="navbarScroll" className="me-0">
							<Nav
								className="my-lg-0"
								navbarScroll
							>
								<Nav.Item className="d-flex align-items-center" style={{margin: 10}}>
									<Nav.Link href="https://netcomet.com.br/" target='_blank' className="d-flex w-100 align-items-center fs-5 color-white">
										<span className="material-icons me-2" aria-hidden="true" role="img">public</span> Site Netcomet
									</Nav.Link>
								</Nav.Item>
							</Nav>
						</Navbar.Brand>
					</Container>
				</Navbar>
				<div className="login-background-wrapper">
					<Container
						fluid
						style={{
							backgroundImage: `url(${backgroundImage})`,
							backgroundPosition: 'bottom',
							backgroundSize: 'cover',
							backgroundRepeat: 'no-repeat',
						}}
						className="bg-light-gray p20 justify-content-center align-items-center d-flex container-login"
					>
						<Col md={isMobile ? 6 : 4} style={{marginBottom: '5%'}}>
							<CardInfo variant="card-login">
								<CardHeader variant="text-center card-header-info">{desafio ? 'Confirme o código' : 'Portal do Cliente'}</CardHeader>
								<CardBody>
									<div className="d-flex justify-content-center w-100 align-items-center flex-column">
										{message && <Alert variant={messageType} className="ms-3 me-3">{message}</Alert>}

										{desafio && !desafio.desafio && <>
											<p className="text-center px-3 mb-0">
												Para proteger a sua conta, na primeira vez em cada navegador pedimos um código de confirmação.
											</p>
											<p className="text-center px-3 mt-2 mb-0">
												Escolha por onde quer receber o código:
											</p>
											<div className="p-3 w-100 d-grid gap-2">
												{(desafio.canais?.sms ?? desafio.destino) && (
													<Button variant="primary w-100 text-start" onClick={() => handleLogin(true, 'sms')}>
														<SmsIcon className="me-2" />SMS para <b>{desafio.canais?.sms ?? desafio.destino}</b>
													</Button>
												)}
												{desafio.canais?.whatsapp && (
													<Button variant="success w-100 text-start" onClick={() => handleLogin(true, 'whatsapp')}>
														<WhatsappIcon className="me-2" />WhatsApp para <b>{desafio.canais.whatsapp}</b>
													</Button>
												)}
												{desafio.canais?.email && (
													<Button variant="secondary w-100 text-start" onClick={() => handleLogin(true, 'email')}>
														<EnvelopeIcon className="me-2" />E-mail para <b>{desafio.canais.email}</b>
													</Button>
												)}
											</div>
											<div className="d-flex justify-content-center w-100 px-3 pb-3">
												<Button variant="link" size="sm" className="text-decoration-none" onClick={() => handleVoltar()}>
													<ArrowLeftIcon className="me-1" />Voltar para o login
												</Button>
											</div>
										</>}

										{desafio && desafio.desafio && <>
											<p className="text-center px-3 mb-0">
												Enviamos por {NOME_CANAL[desafio.canal || canal]} o código de 6 dígitos para <b>{desafio.destino}</b>.
											</p>
											<div className="p-3 w-100">
												<Input
													icon="lock"
													type="tel"
													inputMode="numeric"
													maxLength={6}
													autoFocus
													onKeyDown={(event) => {if (event.key === "Enter") handleVerify()}}
													placeholder="Código de verificação"
													onChange={value => setCodigo(value.target.value.replace(/\D/g, '').slice(0, 6))}
													value={codigo}
												/>
											</div>
											<div className="px-3 w-100">
												<Form.Check
													type="checkbox"
													id="lembrar-navegador"
													checked={lembrar}
													onChange={() => setLembrar(!lembrar)}
													label="Lembrar este navegador (não pedir o código de novo por um tempo)"
												/>
											</div>
											<div className="p-3 w-100">
												<Button variant="primary w-100" onClick={() => handleVerify()}>CONFIRMAR</Button>
											</div>
											<div className="d-flex gap-2 w-100 px-3">
												<Button variant="outline-secondary" size="sm" className="w-50" onClick={() => handleLogin(true, desafio.canal || canal)}>
													<RedoIcon className="me-1" />Reenviar
												</Button>
												<Button variant="outline-secondary" size="sm" className="w-50" onClick={() => handleLogin(false)}>
													<ExchangeIcon className="me-1" />Outro canal
												</Button>
											</div>
											<div className="d-flex justify-content-center w-100 px-3 py-3">
												<Button variant="link" size="sm" className="text-decoration-none" onClick={() => handleVoltar()}>
													<ArrowLeftIcon className="me-1" />Voltar para o login
												</Button>
											</div>
										</>}

										{!desafio && <>
											<div className="p-3 w-100">
												<Input
													icon="face"
													type="tel"
													onKeyDown={(event) => {if (event.key === "Enter") handleLogin()}}
													placeholder="Digite seu CPF ou CNPJ"
													onChange={value => setDocument(cpfCnpjMask(value.target.value))}
													value={document}
												/>
											</div>
											<div className="p-3 w-100">
												<Input
													icon="phone"
													type="tel"
													onKeyDown={(event) => {if (event.key === "Enter") handleLogin()}}
													placeholder="Digite seu Telefone"
													onChange={value => setPhone(phoneMask(value.target.value))}
													value={phone}
												/>
											</div>
											<div className="p-3 w-100">
												<Button variant="primary w-100" onClick={() => handleLogin()}>ENTRAR</Button>
											</div>
										</>}
									</div>
								</CardBody>
							</CardInfo>
							{isMobile && <div style={{justifyItems: 'center'}}>
								<div style={{textAlign: 'center', marginTop: 20}}>
									<h4 className="color-white cocon-bold">BAIXE NOSSO APP</h4>
								</div>
								<div className="d-flex" style={{textAlign: 'center', marginTop: 20}}>
									<img src={appleImg} width={160} alt="Baixe na Apple Store" style={{cursor: 'pointer', marginRight: 15}} onClick={() => window.open('https://apps.apple.com/br/app/netcomet/id6739140081', '_blank')}/>
									<img src={androidImg} width={160} alt="Baixe na App Store" style={{cursor: 'pointer'}} onClick={() => window.open('https://play.google.com/store/apps/details?id=br.com.netcomet.netcometanlise&hl=pt_BR&gl=US', '_blank')}/>
								</div>
							</div>}
						</Col>

						{!isMobile && <div className="download-button-wrapper">
							<div>
								<h4 className="color-white cocon-bold">BAIXE NOSSO APP</h4>
							</div>
							<div>
								<img src={appleImg} width={160} alt="Baixe na Apple Store" style={{cursor: 'pointer', marginRight: 20}} onClick={() => window.open('https://apps.apple.com/br/app/netcomet/id6739140081', '_blank')}/>
								<img src={androidImg} width={160} alt="Baixe na App Store" style={{cursor: 'pointer'}} onClick={() => window.open('https://play.google.com/store/apps/details?id=br.com.netcomet.netcometanlise&hl=pt_BR&gl=US', '_blank')}/>
							</div>
						</div>}

						<div className="social-button-wrapper justify-content-end">
							<div style={{marginRight: '10%', alignSelf: 'end', display: 'flex', color: 'white'}} className="fs-5">
								<div style={{marginRight: 40, cursor: 'pointer', display: 'flex'}} onClick={() => window.open('https://www.instagram.com/netcomet.internet/', '_blank')}>
									<InstagramIcon size={24} color="#fff" />&nbsp;Instagram
								</div>
								<div style={{cursor: 'pointer', display: 'flex'}} onClick={() => window.open('https://www.facebook.com/netcomet/?locale=pt_BR', '_blank')}>
									<FaceboookIcon size={24} color="#fff" />&nbsp;Facebook
								</div>
							</div>
						</div>
					</Container>
				</div>
			</>
			}
		</>
	);
}
